import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../filters';

export default {
  name: 'custdetail_general',
    components: {
        
    },
    data: function () {
        return {
            title: 'Hello Test'
        }
    },
    methods: {
        
    },
}

